module.exports = __webpack_public_path__ + "img/collection-weddingRingsPlatinum.6f79fee.jpg";